module.exports = __webpack_public_path__ + "static/019-slideshow-797c2b5366f9614749a22f9c01e03b88.jpg";